export enum ReservationExaminationStatus {
    OK = 'OK',
    EMPTY = 'EMPTY',
    MANDATORY_FIELD_MISSING = 'MANDATORY_FIELD_MISSING',
}
